/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import moment from 'moment';
import { tagName } from '@ember-decorators/component';

// tagName '' keeps the component boxless so the StickyElement inside resolves
// its containing block to the scroll container and can pin; a wrapper element
// would trap the sticky bar and let it scroll away.
@tagName('')
export default class GroupBanner extends Component {
  @action
  setNavCardOpen(value) {
    this.navCardOpen = value;
  }

  @tracked
  navCardOpen;

  @service
  router;

  GroupType = GroupType;
  @tracked currentYear = moment().year();

  @computed('currentYear', 'group.year')
  get isNonCurrentYear() {
    const year = this.get('group.year');
    // A year of 0 (the Go zero value) means no year.
    return !!year && this.currentYear !== year;
  }

  @computed('isNonCurrentYear')
  get cardClasses() {
    let classNames = ['profile-banner', 'group-profile-banner'];
    if (this.isNonCurrentYear) {
      classNames.push('non-current-year');
    }
    return classNames.join(' ');
  }

  @action
  onDelete() {
    this.router.transitionTo('home');
  }
}
